export default "__VITE_ASSET__qo8YnlHl__"